<template>
  <div v-if="folder?.id" class="view d-flex w-100">
    <folder-view v-if="isFolder" :folder="folder" />
    <assignment-view v-else />
  </div>
  <div v-else>
    <eg-b-overlay :show="true" no-wrap>
      <template #overlay>
        <eg-b-spinner small variant="info" />
      </template>
    </eg-b-overlay>
  </div>
</template>

<script>
import AssignmentView from "@/views/workspace/assignment_view.vue";
import FolderView from "@/views/workspace/folder_view.vue";

export default {
  name: "WorkspaceView",

  components: {
    AssignmentView,
    FolderView,
  },

  inject: ["workspacesProvider"],

  computed: {
    folder() {
      return this.workspacesProvider.getFolderById(
        this.$route.params.workspaceKey,
        +this.$route.params.id
      );
    },

    isFolder() {
      return !this.folder?.isAssignment;
    },

    folderId() {
      return +this.$route.params.id;
    },

    isFoldersLoaded() {
      return !this.workspacesProvider.loadingFolders;
    },
  },

  watch: {
    isFoldersLoaded: {
      handler() {
        this.loadFolder();
      },
      immediate: true,
    },

    "$route.params.id": {
      handler() {
        this.loadFolder();
      },
    },
  },

  methods: {
    loadFolder() {
      if (!this.isFoldersLoaded) {
        return;
      }
      if (!this.folder) {
        this.$showToastError(this.$t("essays.folderNotFound"));
        this.$router.push({ name: "dashboard" });
        return;
      }
      this.workspacesProvider.loadFolderById(
        this.$route.params.workspaceKey,
        this.folderId
      );
    },
  },
};
</script>
